/* eslint-disable react/prop-types */
import { Trans } from '@lingui/macro'
import useScrollPosition from '@react-hook/window-scroll'
import LogoChips from 'assets/svg/casino-chips-ico.svg'
import LogoChipsBlack from 'assets/svg/casino-chips-ico-black.svg'
import DelayLink from 'components/DelayLink'
/* import { CHAIN_INFO } from 'constants/chainInfo'
import { SupportedChainId } from 'constants/chains' */
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import usePlayerData from 'hooks/usePlayerData'
import { darken } from 'polished'
import { ShoppingCart } from 'react-feather'
import { AiOutlineHome } from 'react-icons/ai'
import { FaCoins } from 'react-icons/fa'
import { RiBankLine, RiUserShared2Line } from 'react-icons/ri'
import { TbBuildingBridge } from 'react-icons/tb'
import { Text } from 'rebass'
import { useShowClaimPopup, useToggleSelfClaimModal } from 'state/application/hooks'
import { useDarkModeManager } from 'state/user/hooks'
import { useNativeCurrencyBalances } from 'state/wallet/hooks'
import styled from 'styled-components/macro'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { isMobile } from 'utils/userAgent'

import { ReactComponent as Logo } from '../../assets/svg/logo.svg'
import { ExternalLink } from '../../theme'
import Menu from '../Menu'
import Row from '../Row'
import Web3Status from '../Web3Status'
import HolidayOrnament from './HolidayOrnament'
import NetworkSelector from './NetworkSelector'

const HeaderFrame = styled.div<{ showBackground: boolean }>`
  display: grid;
  grid-template-columns: 120px 1fr 120px;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  padding: 1rem;
  z-index: 21;
  position: relative;
  /* Background slide effect on scroll. */
  background-image: ${({ theme }) => `linear-gradient(to bottom, transparent 50%, ${theme.bg0} 50% )}}`};
  background-position: ${({ showBackground }) => (showBackground ? '0 -100%' : '0 0')};
  background-size: 100% 200%;
  box-shadow: 0px 0px 0px 1px ${({ theme, showBackground }) => (showBackground ? theme.bg2 : 'transparent;')};
  transition: background-position 0.1s, box-shadow 0.1s;
  background-blend-mode: hard-light;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    grid-template-columns: 48px 1fr 1fr;
  `};

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding:  1rem;
    grid-template-columns: 1fr 1fr;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding:  1rem;
    grid-template-columns: 36px 1fr;
  `};
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;

  &:not(:first-child) {
    margin-left: 0.5em;
  }

  /* addresses safaris lack of support for "gap" */
  & > *:not(:first-child) {
    margin-left: 8px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: center;
  `};
`

const HeaderLinks = styled(Row)<{ isMobile?: boolean }>`
  justify-self: center;
  background-color: ${({ theme }) => theme.bg0};
  width: ${({ isMobile }) => (isMobile ? '80%' : 'fit-content')};
  padding: 2px;
  border-radius: 16px;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  overflow: auto;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    justify-self: start;  
    `};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-self: center;
  `};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    justify-content: space-between;
    justify-self: center;
    z-index: 99;
    position: fixed;
    bottom: 0; right: 50%;
    transform: translate(50%,-50%);
    margin: 0 auto;
    background-color: ${({ theme }) => theme.bg0};
    border: 1px solid ${({ theme }) => theme.bg2};
    box-shadow: 0px 6px 10px rgb(0 0 0 / 2%);
  `};
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme, active }) => (!active ? theme.bg0 : theme.bg0)};
  border-radius: 16px;
  white-space: nowrap;
  width: 100%;
  height: 40px;

  :focus {
    border: 1px solid blue;
  }
`

const ATRAmount = styled(AccountElement)<{ isDarkMode: boolean }>`
  color: white;
  padding: 4px 8px;
  height: 36px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.bg3};
  background: ${({ isDarkMode }) =>
    isDarkMode
      ? 'radial-gradient(174.47% 188.91% at 1.84% 0%, #5090ea 0%, #102238 100%), #5090ea'
      : 'radial-gradient(174.47% 188.91% at 1.84% 0%, #943340 0%, #5e2129 100%), #943340'};
`

const ATRWrapper = styled.span`
  width: fit-content;
  position: relative;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }

  :active {
    opacity: 0.9;
  }
`

/* const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
` */

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 4rem;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  :hover {
    cursor: pointer;
  }
`

const UniIcon = styled.div`
  transition: transform 0.5s ease;
  :hover {
    transform: rotate(-5deg);
  }

  position: absolute;
`

const activeClassName = 'ACTIVE'

const StyledNavLink = styled(DelayLink).attrs({
  activeClassName,
  isMobile,
})`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: ${({ isMobile }) => (isMobile ? '0.5rem' : '1rem')};
  font-weight: 500;
  padding: 8px 12px;
  word-break: break-word;
  overflow: hidden;
  white-space: nowrap;
  &.${activeClassName} {
    border-radius: 14px;
    font-weight: 600;
    justify-content: center;
    color: ${({ theme }) => theme.text1};
    background-color: ${({ theme }) => theme.bg1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }
`

const StyledExternalLink = styled(ExternalLink).attrs({
  activeClassName,
  isMobile,
})<{ isActive?: boolean }>`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: ${({ isMobile }) => (isMobile ? '0.5rem' : '1rem')};
  width: fit-content;
  margin: 0 12px;
  font-weight: 500;

  &.${activeClassName} {
    border-radius: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.text1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
    text-decoration: none;
  }
`
const Header = () => {
  const { account } = useActiveWeb3React()

  const userEthBalance = useNativeCurrencyBalances(account ? [account] : [])?.[account ?? '']
  const [darkMode] = useDarkModeManager()
  const playerData = usePlayerData()

  const { chipsBalance, trBalance } = playerData

  const toggleClaimModal = useToggleSelfClaimModal()

  const availableClaim: boolean = trBalance.gt(0)

  /* const { claimTxn } = useUserHasSubmittedClaim(account ?? undefined)*/

  const showClaimPopup = useShowClaimPopup()

  const scrollY = useScrollPosition()

  return (
    <HeaderFrame showBackground={scrollY > 45}>
      <Title href=".">
        <UniIcon>
          <Logo width={isMobile ? '48px' : '64px'} height="100%" title="logo" />
          <HolidayOrnament />
        </UniIcon>
      </Title>
      <HeaderLinks isMobile={isMobile}>
        <StyledNavLink isMobile={isMobile} id={`home-nav-link`} to={'/home'} delay={3500}>
          {isMobile ? <AiOutlineHome size={24} /> : <Trans>Home</Trans>}
        </StyledNavLink>
        <StyledNavLink isMobile={isMobile} id={`chips-nav-link`} to={'/chips'} delay={3500}>
          {isMobile ? <FaCoins size={24} /> : <Trans>Buy Chips</Trans>}
        </StyledNavLink>
        <StyledNavLink isMobile={isMobile} id={`referrals-nav-link`} to={'/referrals'} delay={3500}>
          {isMobile ? <RiUserShared2Line size={24} /> : <Trans>Referrals</Trans>}
        </StyledNavLink>
        <StyledNavLink isMobile={isMobile} id={`stake-nav-link`} to={'/stake'} delay={3500}>
          {isMobile ? <RiBankLine size={24} /> : <Trans>Stake</Trans>}
        </StyledNavLink>
        <StyledExternalLink id={`swc-nav-link`} href="https://app.multichain.org/#/router">
          {isMobile ? (
            <TbBuildingBridge size={24} />
          ) : (
            <>
              <Trans>Bridge</Trans>
            </>
          )}
        </StyledExternalLink>
        <StyledExternalLink
          id={`swc-nav-link`}
          href="https://jamonswap.finance/swap?outputCurrency=0x536a6Bc33010976b07C8e7D08189694125188E4e"
        >
          {isMobile ? (
            <ShoppingCart size={24} />
          ) : (
            <>
              <Trans>Buy SWC</Trans>
            </>
          )}
        </StyledExternalLink>
        {/* <StyledExternalLink id={`charts-nav-link`} href={infoLink}>
          <Trans>Charts</Trans>
          <sup>↗</sup>
        </StyledExternalLink> */}
      </HeaderLinks>

      <HeaderControls>
        <HeaderElement>
          <NetworkSelector />
        </HeaderElement>
        <HeaderElement>
          {/* {availableClaim && !showClaimPopup && (
            <ATRWrapper onClick={toggleClaimModal}>
              <ATRAmount active={!!account && !availableClaim} style={{ pointerEvents: 'auto' }} isDarkMode={darkMode}>
                <ThemedText.White padding="0 2px">
                  {isMobile ? <AiOutlineTrophy size={24} /> : <Trans>Claim ATR</Trans>}
                </ThemedText.White>
              </ATRAmount>
              <CardNoise />
            </ATRWrapper>
          )} */}
          <AccountElement active={!!account}>
            {account ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Text
                  style={{ flexShrink: 0, userSelect: 'none' }}
                  pl="0.75rem"
                  pr="0.5rem"
                  fontWeight={500}
                  fontSize={isMobile ? '12px' : '16px'}
                >
                  {getFullDisplayBalance(chipsBalance, 18, 2)}
                </Text>
                {darkMode ? (
                  <img src={LogoChips} width="24px" height="100%" alt="" />
                ) : (
                  <img src={LogoChipsBlack} width="24px" height="100%" alt="" />
                )}
              </div>
            ) : null}
            <Web3Status />
          </AccountElement>
        </HeaderElement>
        <HeaderElement>
          <Menu />
        </HeaderElement>
      </HeaderControls>
    </HeaderFrame>
  )
}

export default Header
